<div class="fondo">   
    <div class="texts animate__animated animate__backInUp animate__slow">
        <h1>Andamios MULTI-FRONT®</h1>
        <p>El andamio multidireccional Multi-Front®, es un sistema modular galvanizado, fabricado en acero. <br><br>
            Es usado en trabajos donde la utilización de andamios de marco no es eficiente (accesos limitados, obstrucciones, superficies desniveladas, formas no rectangulares).<br><br>
            El sistema multidireccional Multi-Front®, cuenta con conexiones fijas, que una vez nivelada la base permite un montaje rápido y fácil en los niveles superiores.<br><br>
            Resulta un sistema versátil, adaptándose fácilmente a todo tipo de edificios y estructuras.<br><br>
            En relación a su capacidad de carga y rigidez, Multi-Front®, ha demostrado tener excelente respuesta entregando al cliente grandes ventajas de seguridad y duración de las piezas del andamio.</p>
    </div>
    <div class="texts2">

        <ul>Componentes
            <li data-toggle="modal" data-target="#ModalPDF"><a style="cursor:pointer;">Sistema de andamios Multi-front®</a></li>
            <li data-toggle="modal" data-target="#ModalPDF2"><a style="cursor:pointer;">Procediento armado Multi-front®</a></li>	
         </ul>
                      
          
          <div class="modal fade " id="ModalPDF" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-fluid modal-notify modal-info modal-xl" role="document">
              <!--Content-->
              <div class="modal-content ">
                <!--Header-->
               
          
                <!--Body-->
                <div class="modal-body ">
          
                  <object class="PDFdoc" width="100%" height="550px" type="application/pdf" data="/assets/Catalogos/SistemaMultiFront.pdf"></object>
                </div>
          
                <!--Footer-->
                <div class="modal-footer justify-content-center">
              
                  <a type="button" class="btn btn-outline-info waves-effect" data-dismiss="modal">Cerrar <i class="fas fa-times ml-1"></i></a>
                </div>
              </div>
              <!--/.Content-->
            </div>
          </div>


          <div class="modal fade " id="ModalPDF2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-fluid modal-notify modal-info modal-xl" role="document">
              <!--Content-->
              <div class="modal-content ">
                <!--Header-->
               
          
                <!--Body-->
                <div class="modal-body ">
          
                  <object class="PDFdoc" width="100%" height="550px" type="application/pdf" data="/assets/Catalogos/ProcedimientoArmado_MULTI-FRONT(FINAL).pdf"></object>
                </div>
          
                <!--Footer-->
                <div class="modal-footer justify-content-center">
              
                  <a type="button" class="btn btn-outline-info waves-effect" data-dismiss="modal">Cerrar <i class="fas fa-times ml-1"></i></a>
                </div>
              </div>
              <!--/.Content-->
            </div>
          </div>

    </div>

    


    <div class="video">
        <div class="embed-responsive embed-responsive-16by9">
            <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/RCnmaCfZGqs" allowfullscreen></iframe>
          </div>
    </div>
</div> 